import React from "react";
import {
  Box,
  Typography,
  styled,
  Link,
  Grid,
  List,
  ListItemButton,
  ListItemAvatar,
  Avatar,
  ListItemText,
  IconButton,
  Divider,
  CircularProgress,
} from "@mui/material";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { SouthAfricanRand } from "../../utils/helpers";
import { ProductAvailability } from "../../utils/constants";
import { COLORS } from "../../constants";
import { getSuggestedSearches } from "../../utils/searchSuggestions";

const SuggestionBlock = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: "4px",
}));

const ImageContainer = styled(Box)(({ theme }) => ({
  border: `1px solid ${COLORS.border}`, // Adjusted to 1px to match desktop, can change to 2px if preferred
  marginRight: theme.spacing(1),
}));

const ResultsSuggestionsMobile = ({
  searchInput,
  loading,
  products,
  handleAddToCart,
}) => {
  const suggestedSearches = getSuggestedSearches(products, searchInput);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      {/* Suggested Searches Section */}
      <Box sx={{ backgroundColor: COLORS.background, pl: 2, pr: 2 }}>
        <Typography
          variant="caption"
          sx={{ fontWeight: 500, color: COLORS.lightText, mt: 0 }}
        >
          SUGGESTED SEARCHES
        </Typography>
        <Box
          sx={{
            mt: 1,
            display: "flex",
            flexWrap: "nowrap",
            overflowX: "auto",
            gap: 1,
            paddingBottom: 1, // Add padding to ensure scroll thumb is visible
          }}
        >
          {suggestedSearches.length > 0 ? (
            suggestedSearches.map((suggestion, index) => (
              <Link
                key={index}
                href={suggestion.href}
                variant="caption"
                sx={{
                  display: "inline-flex",
                  textDecoration: "none",
                  cursor: "pointer",
                  color: COLORS.darkText,
                  p: 1,
                  whiteSpace: "nowrap", // Prevent text wrapping
                  "&:hover": {
                    color: COLORS.primary,
                    backgroundColor: COLORS.themeYellow,
                  },
                }}
              >
                {suggestion.label}
              </Link>
            ))
          ) : (
            <Typography variant="caption" sx={{ p: 1, color: "grey" }}>
              No suggestions available
            </Typography>
          )}
        </Box>
      </Box>

      {/* Divider */}
      <Box
        sx={{
          width: "100%",
          height: "1px",
          backgroundColor: COLORS.border,
        }}
      />

      {/* Results for ... Section */}
      <Box sx={{ p: 2, flex: 2 }}>
        <Typography
          variant="caption"
          sx={{ fontWeight: 500, color: COLORS.lightText, mt: 0, mb: 1 }}
        >
          Results for "{searchInput}"
        </Typography>
        <>
          {!!loading && (
            <Box sx={{ p: 4, textAlign: "center" }}>
              <CircularProgress />
            </Box>
          )}
          {!loading && (
            <List>
              {products && products.length > 0 ? (
                products.map((item) => (
                  <React.Fragment key={item.sku}>
                    <ListItemButton
                      component="a"
                      href={`/product/${encodeURIComponent(item.sku)}`}
                      sx={{ p: 1.2 }}
                    >
                      <ListItemAvatar>
                        <Avatar
                          alt={item.sku}
                          src={item.image}
                          sx={{
                            width: (theme) => theme.spacing(10),
                            height: (theme) => theme.spacing(10),
                          }}
                          imgProps={{
                            style: {
                              objectFit: "contain",
                            },
                          }}
                        />
                      </ListItemAvatar>
                      <ListItemText
                        sx={{ lineHeight: 1 }}
                        primary={
                          <Typography variant="caption" sx={{}}>
                            {item.name}
                          </Typography>
                        }
                        secondary={
                          <>
                            <Typography
                              variant="subtitle1"
                              color={COLORS.themeRed}
                              fontWeight="bold"
                            >
                              {SouthAfricanRand.format(item.price)}
                            </Typography>
                            {item.invoicePrice > 0 &&
                              item.invoicePrice !== item.itemPrice && (
                                <Typography
                                  variant="subtitle2"
                                  color="textSecondary"
                                >
                                  Invoice:{" "}
                                  {SouthAfricanRand.format(item.invoicePrice)}
                                </Typography>
                              )}
                          </>
                        }
                      />
                      {item.availability !== ProductAvailability.No_Stock && (
                        <IconButton
                          color="error"
                          onClick={(e) => {
                            e.preventDefault();
                            handleAddToCart({
                              id: item.productId,
                              name: item.name,
                              vendor: item.vendor,
                              image: item.image,
                              sku: item.sku,
                            });
                          }}
                          sx={{
                            border: `1px solid ${COLORS.border}`,
                            borderRadius: "2px",
                          }}
                        >
                          <AddShoppingCartIcon
                            fontSize="small"
                            sx={{ color: COLORS.themeRed }}
                          />
                        </IconButton>
                      )}
                    </ListItemButton>
                    <Divider sx={{ borderColor: COLORS.border }} />
                  </React.Fragment>
                ))
              ) : (
                <ListItemText
                  sx={{ p: 1 }}
                  primaryTypographyProps={{ variant: "caption" }}
                >
                  No products found. Please try another search term.
                </ListItemText>
              )}
            </List>
          )}
        </>
      </Box>
      {/* {!loading && products && products.length > 0 && (
        <Link
          href={`/products?search=${encodeURIComponent(searchInput)}&count=${
            products.length
          }`}
          sx={{
            display: "block",
            width: "100%",
            backgroundColor: COLORS.themeYellow,
            color: COLORS.darkText,
            textAlign: "left",
            p: 2,
            textDecoration: "none",
            "&:hover": {
              backgroundColor: COLORS.primary,
              color: COLORS.darkText,
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="caption">Show More Results</Typography>
            <ChevronRightIcon sx={{ color: COLORS.darkText }} />
          </Box>
        </Link>
      )} */}
    </Box>
  );
};

export default ResultsSuggestionsMobile;
